import { defineFetcher } from "~/api/_common/defineFetcher"
import { POST } from "~/api/_common/http"

import { FavoriteBody } from "./_types"

const PATH = "/favorite"

export type PostFavorite = {
  attached: number[]
  detached: number[]
  updated: number[]
}

export const fetchPostFavorite = defineFetcher((body: FavoriteBody): Promise<PostFavorite> => {
  return POST(PATH, body)
})
